import { Container } from "pixi.js";

import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Meter } from "./Meter";


export class MeterComponent extends AbstractDisplayComponent {
    private container: Container;

    public override init() {
        let containerConfig = {
            labelName: "meter_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1024,
                posY: 1370,
                scale: 1.1,
            },
            portrait: {
                posX: 1024,
                posY: 1370,
                scale: 1.1,
            }
        };

        this.container = new Meter(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

    public activate(id: number, callback: () => void) {
        (this.container as Meter).activate(id, callback);
    }

    public deActivate(id: number) {
        (this.container as Meter).deActivate(id);
    }

    public reset(id: number) {
        (this.container as Meter).static(id);
    }
}
